import { render, staticRenderFns } from "./ColAction.vue?vue&type=template&id=ac4d4670&"
import script from "./ColAction.vue?vue&type=script&lang=js&"
export * from "./ColAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports